import React, { useEffect, useRef } from 'react';
import { Undo2, X } from 'lucide-react';

export const UNDO_MS = 6000;

// "Removed 5012345678900  [Undo]" bar. Toasts have no action button, so the stock take
// keeps its own. `undo` is { id, message } or null; a new id restarts the timer.
const UndoBar = ({ undo, onUndo, onDismiss }) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!undo) return undefined;
    const timer = setTimeout(() => onDismissRef.current(), UNDO_MS);
    return () => clearTimeout(timer);
  }, [undo]);

  if (!undo) return null;

  return (
    <div className="st-undo-bar" role="status" aria-live="polite" key={undo.id}>
      <span className="st-undo-message">{undo.message}</span>
      <button type="button" className="st-undo-btn" onClick={onUndo}>
        <Undo2 size={18} aria-hidden="true" /> Undo
      </button>
      <button type="button" className="st-undo-close" onClick={onDismiss} aria-label="Dismiss">
        <X size={18} aria-hidden="true" />
      </button>
    </div>
  );
};

export default UndoBar;
